import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  List,
  ListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useStyles } from "../../../theme/appStyles";
import {
  useGetTeamQuery,
  useGetDepartmentQuery,
  useGetPositionQuery,
  useGetPunchDetailsEmpQuery,
  useGetSaveEmployeePayrollAnEmployeeRecordQuery,
  useGetAllPayrollRecordeDateRangeQuery,
  useGetSaveAnEmployeePayRollAdminQuery,
  useGetSaveAnEmplEachRecordPayRollAdminQuery,
  usePayrollRecordeEmpQuery,
} from "../../../Api/attoDeskApi";
import {
  ITeam,
  IDepartment,
  IPosition,
  IPunchDetails,
  IEmployeePayroll,
  IPayrollDateRangeList,
  IEmployeePunchRecord,
  IPayrollEachEmployeDateList,
  IPunchEmpRecord,
} from "../../../Api/Interface/api.interface";
import NewPopUpteam from "../Edit/index";
import NewPopUpteamscheduleEdit from "../Edit/scheduleEdit";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import * as XLSX from "xlsx";
import AvatarImg from "../../../Images/avatar.png";
import {
  formatPhoneNumberForDisplay,
  formatPhoneNumberForDisplaySpace,
} from "../../../Components/Validation/validationUtils";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import AttachMoneySharpIcon from "@mui/icons-material/AttachMoneySharp";
import useUser from "../../../Core/hook/useUser";
import { Privileges } from "../../../Core/Enum/enum";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ListIcon from "@mui/icons-material/List";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import Pagination from "../../../Components/Pagination";
import LogoMain from "../../../Images/logo.webp";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toAllCaps } from "../../../Components/Validation/toAllCaps";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

enum Section {
  Info = "Info",
  Email = "Email",
  Email2 = "Email2",
  TimeSlot = "TimeSlot",
  Payroll = "Payroll",
  Attendance = "Attendance",
}

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index = () => {
  const classes = useStyles();
  const [activeSection, setActiveSection] = useState<Section>(Section.Info);
  const handleContainerChange = (section: Section) => {
    setActiveSection(section);
  };
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const { id: customerId } = useParams<{ id: string }>();
  const { userHasRight } = useUser();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectCustomer, setSelectCustomer] = useState<ITeam | null>(null);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [selectCustomer2, setSelectCustomer2] = useState<ITeam | null>(null);
  useEffect(() => {}, [customerId]);
  const [showPassword, setShowPassword] = useState(false);
  const [expandedSteps, setExpandedSteps] = useState<number[]>([]);
  const [selectedEmpId, setSelectedEmpId] = useState<string | undefined>("");
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState<IEmployeePayroll | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [selectedPayrollId, setSelectedPayrollId] = useState<
    string | undefined
  >("");
  const [selectedHrs, setSelectedHrs] = useState<string | undefined>("0.00");
  const [coursingToDelete, setCoursingToDelete] =
    useState<IEmployeePayroll | null>(null);

  const [selectedRecordDate, setSelectedRecordDate] = useState<
    string | undefined
  >("");

  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | undefined>(
    undefined
  );

  const { data, isLoading, isError } = useGetTeamQuery({
    searchText: "",
    id: String(customerId),
  });
  const [openAdminConfim, setOpenAdminConfim] = useState<boolean>(false);

  const { data: activityData, isLoading: activityIsLoading } =
    useGetPunchDetailsEmpQuery({
      empid: String(customerId),
    });

  const { data: departmentData, isLoading: departmentLoading } =
    useGetDepartmentQuery({
      searchText: "",
    });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: payrollData,
    isLoading: payrollIsLoading,
    isError: payrollIsError,
  } = useGetSaveEmployeePayrollAnEmployeeRecordQuery({
    empid: String(customerId),
  });

  const {
    data: payrollListData,
    isLoading: payrollEmpIsLoading,
    isError: payrollEmpIsError,
    refetch: payrollEmpListRefetch,
  } = useGetAllPayrollRecordeDateRangeQuery();

  const {
    data: payRollAnEmployeeData,
    isLoading: payRollAnEmployeeLoading,
    error: payRollAnEmployeeIsError,
  } = useGetSaveAnEmployeePayRollAdminQuery(
    selectedEmpId && selectedPayrollId
      ? {
          empid: selectedEmpId,
          payrollId: String(selectedPayrollId),
        }
      : { empid: "", payrollId: "" },
    { skip: !selectedEmpId || !selectedPayrollId }
  );

  const {
    data: payRollEachEmployeeData,
    isLoading: payRollEachEmployeeLoading,
    error: payRollEachEmployeeIsError,
  } = useGetSaveAnEmplEachRecordPayRollAdminQuery(
    selectedEmpId && selectedRecordDate && selectedPayrollId
      ? {
          empid: selectedEmpId,
          payrollId: String(selectedPayrollId),
          recordDate: String(selectedRecordDate),
        }
      : { empid: "", payrollId: "", recordDate: "" },
    { skip: !selectedEmpId || !selectedRecordDate || !selectedPayrollId }
  );

  const {
    data: attendanceData,
    isLoading: attendanceIsLoading,
    isError: attendanceIsError,
    refetch: attendanceRefetch,
  } = usePayrollRecordeEmpQuery(
    selectedStartDate && selectedEndDate
      ? {
          empid: String(customerId),
          startDate: selectedStartDate.format("YYYY-MM-DD"),
          endDate: selectedEndDate.format("YYYY-MM-DD"),
        }
      : { empid: String(customerId), startDate: "", endDate: "" }
  );

  const departmentList = useMemo(() => {
    return departmentData?.data as IDepartment[];
  }, [departmentData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const payrollEmpList = useMemo(() => {
    return payrollListData?.data as IPayrollDateRangeList[];
  }, [payrollListData?.data]);

  const departmentMap = useMemo(() => {
    const map = new Map();
    departmentList?.forEach((category) => {
      map.set(category.id, category.departmentName);
    });
    return map;
  }, [departmentList]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const payrollMap = useMemo(() => {
    const map = new Map();

    payrollEmpList?.forEach((category) => {
      map.set(
        category.id,
        `${dayjs(category.startDate).format("MMM-DD, YYYY")} - ${dayjs(
          category.endDate
        ).format("MMM-DD, YYYY")}`
      );
    });

    return map;
  }, [payrollEmpList]);

  const payrollMapForPrint = useMemo(() => {
    const map = new Map();

    payrollEmpList?.forEach((category) => {
      map.set(category.id, {
        ...category, // Preserve original properties
        formattedStartDate: dayjs(category.startDate).format("MMM-DD, YYYY"),
        formattedEndDate: dayjs(category.endDate).format("MMM-DD, YYYY"),
      });
    });

    return map;
  }, [payrollEmpList]);

  // const payrollMapForPrint = useMemo(() => {
  //   const map = new Map<number | string, IPayrollDateRangeList & { formattedStartDate: string; formattedEndDate: string }>();

  //   payrollEmpList?.forEach((category: IPayrollDateRangeList) => {
  //     map.set(category.id, {
  //       ...category, // Preserve original properties
  //       formattedStartDate: dayjs(category.startDate).format("MMM-DD, YYYY"),
  //       formattedEndDate: dayjs(category.endDate).format("MMM-DD, YYYY"),
  //     });
  //   });

  //   return map;
  // }, [payrollEmpList]);

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ITeam;
    }
    return null;
  }, [data]);

  const payrollDataList: IEmployeePayroll[] = Array.isArray(payrollData?.data)
    ? (payrollData?.data as IEmployeePayroll[])
    : [];

  const EmployeePunchRecord: IEmployeePunchRecord[] = Array.isArray(
    payRollAnEmployeeData?.data
  )
    ? (payRollAnEmployeeData?.data as IEmployeePunchRecord[])
    : [];

  const EmpEachPunchRecord: IPayrollEachEmployeDateList[] = Array.isArray(
    payRollEachEmployeeData?.data
  )
    ? (payRollEachEmployeeData?.data as IPayrollEachEmployeDateList[])
    : [];

  // const attendanceDataList: IPunchEmpRecord[] = Array.isArray(
  //   attendanceData?.data
  // )
  //   ? (attendanceData?.data as IPunchEmpRecord[])
  //   : [];

  const attendanceDataList: IPunchEmpRecord[] = attendanceData?.data
    ? Object.entries(attendanceData.data).flatMap(([date, records]) =>
        (records as IPunchEmpRecord[]).map((record) => ({
          ...record,
          punch_in_date: date,
        }))
      )
    : [];

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setSelectedStartDate(newValue ?? undefined);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setSelectedEndDate(newValue ?? undefined);
  };

  const goToPreviousDay = () => {
    const prevDay =
      selectedStartDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleStartDateChange(prevDay);
  };

  const goToNextDay = () => {
    const nextDay = selectedStartDate?.add(1, "day") || dayjs().add(1, "day");
    handleStartDateChange(nextDay);
  };

  const goToPreviousDayEnd = () => {
    const prevDay =
      selectedEndDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleEndDateChange(prevDay);
  };

  const goToNextDayEnd = () => {
    const nextDay = selectedEndDate?.add(1, "day") || dayjs().add(1, "day");
    handleEndDateChange(nextDay);
  };

  const handleOpenEditSuites = () => {
    setSelectCustomer(customer);
    setOpenDialog(true);
  };

  const handleOpenEditSuites2 = () => {
    setSelectCustomer2(customer);
    setOpenDialog2(true);
  };

  const handleCloseDialog = () => {
    setSelectCustomer(null);
    setOpenDialog(false);
  };

  const handleCloseDialog2 = () => {
    setSelectCustomer2(null);
    setOpenDialog2(false);
  };

  const handleViewClick = (
    empid: string,
    payrollId: string,
    hourly_salary: string,
    coursing: IEmployeePayroll
  ) => {
    setSelectedPayrollId(payrollId);
    setSelectedEmpId(empid);
    setSelectedHrs(hourly_salary);
    setCoursingToDelete(coursing);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmpId(undefined);
    setSelectedHrs(undefined);
    setCoursingToDelete(null);
  };

  const handleEditOpen = (row: IEmployeePayroll) => {
    setEditData(row);
    setIsEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditData(null);
    setIsEditDialogOpen(false);
  };

  const handleDateViewClick = (recordDate: string) => {
    setSelectedRecordDate(recordDate);
    setOpenAdminConfim(true);
  };

  const handleDialogCloseAdminConform = (confirmed: boolean) => {
    setOpenAdminConfim(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const exportToExcel = () => {
    const data: (string | number)[][] = [];
    data.push(["Day", "Start Time", "End Time"]);

    customer?.availability
      .filter((day) => day.timeSlots.length > 0)
      .forEach((day) => {
        day.timeSlots.forEach((slot) => {
          data.push([day.day, slot.startTime, slot.endTime]);
        });
      });

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Availability");

    XLSX.writeFile(workbook, "customer_availability.xlsx");
  };

  const handleExportToExcel = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const exportData = payrollDataList.map((row, index) => ({
      Payroll: payrollMap.get(row.payrollId) || "",
      "Normal Hours": getSafeToFixed(row.total_normal_hours),
      "Hourly Salary": getSafeToFixed(row.hourly_salary),
      // "Overtime Hours": getSafeToFixed(row.total_ot_hours),
      // "Overtime Hourly Salary": getSafeToFixed(row.ot_hourly_salary),
      "Gross Salary": getSafeToFixed(row.gross_salary),
      //"OT Salary": getSafeToFixed(row.ot_salary),
      "OT Salary":
        row.ot_salary !== null &&
        !isNaN(parseFloat(String(row.ot_salary))) &&
        parseFloat(String(row.ot_salary)) > 0
          ? row.ot_salary !== null && !isNaN(parseFloat(String(row.ot_salary)))
            ? parseFloat(String(row.ot_salary)).toFixed(2)
            : "-"
          : "-",

      // "Adjustment Amount": getSafeToFixed(row.bonus_amount),
      "Adjustment Amount":
        row.bonus_amount !== null &&
        !isNaN(parseFloat(String(row.bonus_amount))) &&
        parseFloat(String(row.bonus_amount)) > 0
          ? row.bonus_amount !== null &&
            !isNaN(parseFloat(String(row.bonus_amount)))
            ? parseFloat(String(row.bonus_amount)).toFixed(2)
            : "-"
          : "-",
      "Total Amount": getSafeToFixed(row.total_salary),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "payrollList");

    const employeeName = payrollDataList[0]?.employee_name || "employee";

    XLSX.writeFile(workbook, `${employeeName}_payrollList.xlsx`);
  };

  const handleExportToPDF = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const tableData = payrollDataList.map((row, index) => [
      payrollMap.get(row.payrollId),
      getSafeToFixed(row.total_normal_hours),
      getSafeToFixed(row.hourly_salary),
      // getSafeToFixed(row.total_ot_hours),
      // getSafeToFixed(row.ot_hourly_salary),
      getSafeToFixed(row.gross_salary),
      // getSafeToFixed(row.ot_salary),

      row.ot_salary !== null &&
      !isNaN(parseFloat(String(row.ot_salary))) &&
      parseFloat(String(row.ot_salary)) > 0
        ? row.ot_salary !== null && !isNaN(parseFloat(String(row.ot_salary)))
          ? parseFloat(String(row.ot_salary)).toFixed(2)
          : "-"
        : "-",
      // getSafeToFixed(row.bonus_amount),

      row.bonus_amount !== null &&
      !isNaN(parseFloat(String(row.bonus_amount))) &&
      parseFloat(String(row.bonus_amount)) > 0
        ? row.bonus_amount !== null &&
          !isNaN(parseFloat(String(row.bonus_amount)))
          ? parseFloat(String(row.bonus_amount)).toFixed(2)
          : "-"
        : "-",
      getSafeToFixed(row.total_salary),
    ]);
    const tableHeaders = [
      [
        "Payroll",
        "Normal Hours",
        "Hourly Salary",
        // "OT Hours",
        // "OT Hourly Salary",
        "Gross Salary",
        "OT Salary",
        "Adjustment Amount",
        "Total Amount",
      ],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");
    const selectedName =
      (customer?.teamFirstName || "") + " " + (customer?.teamLastName || "");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 15;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 10;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Payroll List - ${selectedName}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`${currentMonth}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `PayrollList_all_${selectedName}.pdf`;

      doc.save(fileName);
    };
  };

  const selectedPayroll = payrollMapForPrint.get(Number(selectedPayrollId));

  const startDatePdf = selectedPayroll?.formattedStartDate || "";
  const endDatePdf = selectedPayroll?.formattedEndDate || "";

  const handleExportToPDFForEmployeePunch = () => {
    const tableData = EmployeePunchRecord.map((row, index) => [
      dayjs(row.recordDate).format("YYYY-MM-DD"),
      row.punchDetails.length > 0
        ? row.punchDetails
            .map(
              (punchDetail) =>
                `${formatTime(punchDetail.punch_in_time)} - ${formatTime(
                  punchDetail.punch_out_time
                )}`
            )
            .join(", ")
        : "",
      row.break_hours === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(row.break_hours))) ||
      isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours)) ===
          0
        ? "-"
        : `${(
            parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours))
          ).toFixed(2)} hrs`,
      row.break_hours === null || isNaN(parseFloat(String(row.break_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.break_hours)).toFixed(2)} hrs`,
      row.total_hours === null || isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.total_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.total_hours)).toFixed(2)} hrs`,
      selectedHrs === null || isNaN(parseFloat(String(selectedHrs)))
        ? ""
        : parseFloat(String(selectedHrs)) === 0
        ? "-"
        : `$ ${parseFloat(String(selectedHrs)).toFixed(2)}`,
      selectedHrs === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(selectedHrs)) * row.total_hours)
        ? ""
        : parseFloat(String(selectedHrs)) * row.total_hours === 0
        ? "-"
        : `$ ${(parseFloat(String(selectedHrs)) * row.total_hours).toFixed(2)}`,
    ]);

    tableData.push([
      "",
      "",
      "",
      coursingToDelete &&
      coursingToDelete.total_break_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_break_hours)))
        ? parseFloat(String(coursingToDelete.total_break_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_break_hours)).toFixed(
              2
            )} hrs`
        : "",
      coursingToDelete &&
      coursingToDelete.total_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_hours)))
        ? parseFloat(String(coursingToDelete.total_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_hours)).toFixed(2)} hrs`
        : "",
      "",
      coursingToDelete &&
      coursingToDelete.gross_salary !== null &&
      !isNaN(parseFloat(String(coursingToDelete.gross_salary)))
        ? parseFloat(String(coursingToDelete.gross_salary)) === 0
          ? "-"
          : `$ ${parseFloat(String(coursingToDelete.gross_salary)).toFixed(2)}`
        : "",
    ]);

    const tableHeaders = [
      [
        "Date",
        "Records",
        "Actual Hours",
        "Total Break Hours",
        "Total working hours",
        "Hourly Salary",
        "Total Amount",
      ],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");
    const selectedName =
      (customer?.teamFirstName || "") + " " + (customer?.teamLastName || "");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 15;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 10;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Payroll Summary - ${selectedName}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(
        `Period: ${startDatePdf} to ${endDatePdf}`,
        textStartY + 5
      );

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `PayrollSummary_${startDatePdf}_to_${endDatePdf}_${selectedName}.pdf`;

      doc.save(fileName);
    };
  };

  const handleEmployeePunchExcel = () => {
    const tableData = EmployeePunchRecord.map((row, index) => [
      dayjs(row.recordDate).format("YYYY-MM-DD"),
      row.punchDetails.length > 0
        ? row.punchDetails
            .map(
              (punchDetail) =>
                `${formatTime(punchDetail.punch_in_time)} - ${formatTime(
                  punchDetail.punch_out_time
                )}`
            )
            .join(", ")
        : "",
      row.break_hours === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(row.break_hours))) ||
      isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours)) ===
          0
        ? "-"
        : `${(
            parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours))
          ).toFixed(2)} hrs`,
      row.break_hours === null || isNaN(parseFloat(String(row.break_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.break_hours)).toFixed(2)} hrs`,
      row.total_hours === null || isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.total_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.total_hours)).toFixed(2)} hrs`,
      selectedHrs === null || isNaN(parseFloat(String(selectedHrs)))
        ? ""
        : parseFloat(String(selectedHrs)) === 0
        ? "-"
        : `$ ${parseFloat(String(selectedHrs)).toFixed(2)}`,
      selectedHrs === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(selectedHrs)) * row.total_hours)
        ? ""
        : parseFloat(String(selectedHrs)) * row.total_hours === 0
        ? "-"
        : `$ ${(parseFloat(String(selectedHrs)) * row.total_hours).toFixed(2)}`,
    ]);

    tableData.push([
      "",
      "",
      "",
      coursingToDelete &&
      coursingToDelete.total_break_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_break_hours)))
        ? parseFloat(String(coursingToDelete.total_break_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_break_hours)).toFixed(
              2
            )} hrs`
        : "",
      coursingToDelete &&
      coursingToDelete.total_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_hours)))
        ? parseFloat(String(coursingToDelete.total_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_hours)).toFixed(2)} hrs`
        : "",
      "",
      coursingToDelete &&
      coursingToDelete.gross_salary !== null &&
      !isNaN(parseFloat(String(coursingToDelete.gross_salary)))
        ? parseFloat(String(coursingToDelete.gross_salary)) === 0
          ? "-"
          : `$ ${parseFloat(String(coursingToDelete.gross_salary)).toFixed(2)}`
        : "",
    ]);

    const tableHeaders = [
      [
        "Date",
        "Records",
        "Actual Hours",
        "Total Break Hours",
        "Total working hours",
        "Hourly Salary",
        "Total Amount",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders[0], ...tableData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "attendanceList");
    const selectedName =
      (customer?.teamFirstName || "") + " " + (customer?.teamLastName || "");

    const fileName = `PayrollSummary_${startDatePdf}_to_${endDatePdf}_${selectedName}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToAttendancePDF = () => {
    const tableHeaders = [["Date", "Clocked Hours", "Records"]];

    // const tableData = Object.entries(attendanceData?.data || {}).map(
    //   ([date, records]) => {
    //     const clockedHours = records
    //       .map(
    //         (record: IPunchEmpRecord) =>
    //           `${formatTime(record.punch_in_time)} - ${
    //             formatTime(record.punch_out_time) || "Pending"
    //           }`
    //       )
    //       .join(", ");

    //     const actualClockedHours = records
    //       .map(
    //         (record: IPunchEmpRecord) =>
    //           `${formatTime(record.punch_in_actual_time)} - ${
    //             formatTime(record.punch_out_actual_time) || "Pending"
    //           }`
    //       )
    //       .join(", ");

    //     return [
    //       dayjs(date).format("MMM-DD, YYYY (dddd)"),
    //       actualClockedHours,
    //       clockedHours,
    //     ];
    //   }
    // );

    const tableData = Object.entries(attendanceData?.data || {}).map(
      ([date, records]) => {
        const clockedHours = records
          .map((record: IPunchEmpRecord) => {
            const punchIn = formatTime(record.punch_in_time);
            const punchOut = record.punch_out_time
              ? formatTime(record.punch_out_time)
              : "";

            return punchIn ? `${punchIn} - ${punchOut || "pending"}` : "";
          })
          .join(", ");

        const actualClockedHours = records
          .map((record: IPunchEmpRecord) => {
            const punchInActual = formatTime(record.punch_in_actual_time);
            const punchOutActual = record.punch_out_actual_time
              ? formatTime(record.punch_out_actual_time)
              : "";

            return punchInActual
              ? `${punchInActual} - ${punchOutActual || "pending"}`
              : "";
          })
          .join(", ");

        return [
          dayjs(date).format("MMM-DD, YYYY (dddd)"),
          actualClockedHours,
          clockedHours,
        ];
      }
    );

    const currentMonth = dayjs().format("YYYY MMM, DD");
    const selectedName = `${customer?.teamFirstName || ""} ${
      customer?.teamLastName || ""
    }`;

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 15;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 10;

    const startDateText = selectedStartDate
      ? selectedStartDate.format("YYYY-MM-DD")
      : "";
    const endDateText = selectedEndDate
      ? selectedEndDate.format("YYYY-MM-DD")
      : "";

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Clock In/Out List - ${selectedName}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      if (startDateText && endDateText) {
        rightAlignText(
          `Period: ${startDateText} to ${endDateText}`,
          textStartY + 5
        );
      }

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `AttendanceList_${startDateText}_to_${endDateText}_${selectedName}.pdf`;

      doc.save(fileName);
    };
  };

  const handleExportToAttendanceExcel = () => {
    // const tableData = Object.entries(attendanceData?.data || {}).map(
    //   ([date, records]) => {
    //     const clockedHours = records
    //       .map(
    //         (record: IPunchEmpRecord) =>
    //           `${formatTime(record.punch_in_time)} - ${
    //             formatTime(record.punch_out_time) || "Pending"
    //           }`
    //       )
    //       .join(", ");

    //     const actualClockedHours = records
    //       .map(
    //         (record: IPunchEmpRecord) =>
    //           `${formatTime(record.punch_in_actual_time)} - ${
    //             formatTime(record.punch_out_actual_time) || "Pending"
    //           }`
    //       )
    //       .join(", ");

    //     return [
    //       dayjs(date).format("MMM-DD, YYYY (dddd)"),
    //       actualClockedHours,
    //       clockedHours,
    //     ];
    //   }
    // );

    const tableData = Object.entries(attendanceData?.data || {}).map(
      ([date, records]) => {
        const clockedHours = records
          .map((record: IPunchEmpRecord) => {
            const punchIn = formatTime(record.punch_in_time);
            const punchOut = record.punch_out_time
              ? formatTime(record.punch_out_time)
              : "";

            return punchIn ? `${punchIn} - ${punchOut || "pending"}` : "";
          })
          .join(", ");

        const actualClockedHours = records
          .map((record: IPunchEmpRecord) => {
            const punchInActual = formatTime(record.punch_in_actual_time);
            const punchOutActual = record.punch_out_actual_time
              ? formatTime(record.punch_out_actual_time)
              : "";

            return punchInActual
              ? `${punchInActual} - ${punchOutActual || "pending"}`
              : "";
          })
          .join(", ");

        return [
          dayjs(date).format("MMM-DD, YYYY (dddd)"),
          actualClockedHours,
          clockedHours,
        ];
      }
    );

    const tableHeaders = ["Date", "Clocked Hours", "Records"];

    const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "attendanceList");

    const selectedName = `${customer?.teamFirstName || ""} ${
      customer?.teamLastName || ""
    }`;

    const startDateText = selectedStartDate
      ? selectedStartDate.format("YYYY-MM-DD")
      : "";
    const endDateText = selectedEndDate
      ? selectedEndDate.format("YYYY-MM-DD")
      : "";

    XLSX.writeFile(
      workbook,
      `attendanceList_${startDateText}_to_${endDateText}_${selectedName}.xlsx`
    );
  };

  if (
    isLoading ||
    departmentLoading ||
    positionLoading ||
    payrollIsLoading ||
    payrollEmpIsLoading ||
    activityIsLoading ||
    attendanceIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching Staff data. Please try again later.
      </Typography>
    );
  }

  if (!customer) {
    return <Typography>No Staff data available.</Typography>;
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleAddProductClick = () => {
    navigate(`/team/schedule/pdf/${customerId}`);
  };

  const renderContent = () => {
    switch (activeSection) {
      case Section.Info:
        return (
          <div>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card} sx={{ minHeight: 500 }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 3, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography className={classes.cardTitle}>
                        Profile
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.editButtonListProfile}
                            onClick={handleOpenEditSuites}
                          >
                            <EditSharpIcon
                              className={classes.editListIconProfileAddColor}
                            />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2} sx={{ padding: 2 }}>
                        {(customer.teamFirstName ||
                          customer.teamLastName ||
                          customer.teamId ||
                          customer.teamEmail ||
                          customer.teamMobileNum) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {(customer.teamFirstName ||
                                      customer.teamLastName) && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Full Name
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {`${capitalizeFirstLetter(
                                              customer.teamFirstName || ""
                                            )} ${capitalizeFirstLetter(
                                              customer.teamLastName || ""
                                            )}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.teamId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Staff Id
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.teamId}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.teamEmail && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            E-mail
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.teamEmail.toLowerCase()}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.teamMobileNum && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Call
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {formatPhoneNumberForDisplay(
                                              customer.teamMobileNum
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {(customer.teamDepartmentId ||
                          customer.teamPositionId ||
                          customer.teamUserName) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {customer.teamDepartmentId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Department
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {departmentMap.get(
                                              customer.teamDepartmentId
                                            ) || ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.teamPositionId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Position
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {postionMap.get(
                                              customer.teamPositionId
                                            ) || ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.teamUserName && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            User Name
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.teamUserName}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {(customer.teamStreet ||
                          customer.teamCity ||
                          customer.teamProvince ||
                          customer.teamPostalCode) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {(customer.teamStreet ||
                                      customer.teamCity ||
                                      customer.teamProvince ||
                                      customer.teamPostalCode) && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Primary Address
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {capitalizeFirstLetter(
                                              customer.teamStreet
                                            )}
                                          </Typography>
                                          <Typography>
                                            {customer?.teamCity
                                              ? `${capitalizeFirstLetter(
                                                  customer.teamCity
                                                )}, `
                                              : ""}
                                            {customer?.teamPostalCode
                                              ? `${capitalizeFirstLetter(
                                                  customer.teamProvince
                                                )} `
                                              : ""}
                                            {customer?.teamPostalCode
                                              ? `${toAllCaps(
                                                  customer.teamPostalCode
                                                )}`
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {customer.teamDescription && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {customer.teamDescription && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={2} md={3} sm={3} xs={3}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Remark
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={10} md={9} sm={9} xs={9}>
                                          <Typography>
                                            {customer.teamDescription}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Email2:
        return (
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
              <Card className={classes.stepperCard}>
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        className={classes.titleGridBottomBoredr}
                      >
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, py: 2, px: 5 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={12}
                            xs={12}
                            pt={2}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              alignContent: "center",
                            }}
                          >
                            <Typography className={classes.cardTitle}>
                              Staff Details
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={12}
                            xs={12}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <Button
                                  startIcon={<EditSharpIcon />}
                                  className={classes.addButtonPdfExcel}
                                  onClick={handleOpenEditSuites}
                                >
                                  Edit
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.backgroundColorView2}
                            sx={{ pt: 3, px: 3 }}
                          >
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  <span className={classes.customerDetails}>
                                    Mobile
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography className={classes.staffTypograpy}>
                                  {formatPhoneNumberForDisplay(
                                    customer.teamMobileNum
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.backgroundColorView2}
                            sx={{ pb: 3, px: 3 }}
                          >
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  <span className={classes.customerDetails}>
                                    Alt Mobile Number
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography className={classes.staffTypograpy}>
                                  {formatPhoneNumberForDisplay(
                                    customer.teamAltMobileNum
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.backgroundColorView2}
                            sx={{ py: 3, px: 3 }}
                          >
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  <span className={classes.customerDetails}>
                                    E-mail
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography className={classes.staffTypograpy}>
                                  {customer.teamEmail}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.backgroundColorView2}
                            sx={{ py: 3, px: 3 }}
                          >
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  <span className={classes.customerDetails}>
                                    Home
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography>{customer.teamAddress}</Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.backgroundColorView2}
                            sx={{ py: 3, px: 3, minHeight: "150px" }}
                          >
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  <span className={classes.customerDetails}>
                                    Note
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography>
                                  {customer.teamDescription}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        );
      case Section.TimeSlot:
        return (
          <Grid container spacing={2}>
            {customer.availability && customer.availability.length > 0 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Schedule List
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Button
                            startIcon={<TableViewIcon />}
                            className={classes.addButtonPdfExcel}
                            onClick={exportToExcel}
                          >
                            Excel
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            startIcon={<LocalPrintshopSharpIcon />}
                            className={classes.addButtonPdfExcel}
                            onClick={handleAddProductClick}
                          >
                            pdf
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                                                  startIcon={<EditSharpIcon />}
                                                  className={classes.ordeListEditButton}
                            onClick={handleOpenEditSuites2}
                          >
                            Edit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                            <TableCell className={classes.tablheader}>
                              <strong>Day</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>Start Time</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>End Time</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>Hourly Salary</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {customer.availability
                            .filter((day) => day.timeSlots.length > 0) // Only include days with timeSlots
                            .map((day) =>
                              day.timeSlots.map((slot) => (
                                <TableRow
                                  key={`${day.day}-${slot.id}`}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell className={classes.tablCell}>
                                    {day.day}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    {formatTime(slot.startTime)}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    {formatTime(slot.endTime)}
                                    {slot.spansNextDay ==true && (
                                      <span
                                        style={{
                                          color: "#e3791a",
                                          fontWeight: 600,
                                          lineHeight: 1.5,
                                          fontSize: "0.875rem",
                                          paddingLeft: "1px",
                                        }}
                                      >
                                        [next day]
                                      </span>
                                    )}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    {"$"}
                                    {slot.hourlySalary
                                      ? Number(slot.hourlySalary).toFixed(2)
                                      : "0.00"}
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Card>
              </Grid>
            ) : (
              <div>No availability data to show</div>
            )}
          </Grid>
        );
        case Section.Attendance:
          return (
            <Grid container spacing={2}>
              {customer.availability && customer.availability.length > 0 ? (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Clock In/Out List
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={8}
                        md={8}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <List className={classes.ListPayroll}>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToPreviousDay}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowLeftIcon />
                                </IconButton>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <Button
                                  className={classes.ListItemPayrollToday}
                                  // onClick={goToToday}
                                  // aria-label="Today"
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={selectedStartDate}
                                      onChange={handleStartDateChange}
                                      slotProps={{
                                        textField: {
                                          placeholder: "Start Date",
                                          size: "small",
                                          sx: {
                                            width: "140px",
                                          },
                                          InputProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                            // classes: {
                                            //   // root: classes.textFieldQuote,
                                            // },
                                            classes: {
                                              root: classes.formControlListStatus,
                                              notchedOutline:
                                                classes.notchedOutline,
                                            },
                                          },
                                          InputLabelProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Button>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToNextDay}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowRightIcon />
                                </IconButton>
                              </ListItem>
                            </List>
                          </Grid>
                          <Grid item>
                            <List className={classes.ListPayroll}>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToPreviousDayEnd}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowLeftIcon />
                                </IconButton>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <Button
                                  className={classes.ListItemPayrollToday}
                                  // onClick={goToToday}
                                  // aria-label="Today"
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={selectedEndDate}
                                      onChange={handleEndDateChange}
                                      slotProps={{
                                        textField: {
                                          placeholder: "End Date",
                                          size: "small",
                                          sx: {
                                            width: "140px",
                                          },
                                          InputProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                            // classes: {
                                            //   // root: classes.textFieldQuote,
                                            // },
                                            classes: {
                                              root: classes.formControlListStatus,
                                              notchedOutline:
                                                classes.notchedOutline,
                                            },
                                          },
                                          InputLabelProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Button>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToNextDayEnd}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowRightIcon />
                                </IconButton>
                              </ListItem>
                            </List>
                          </Grid>
                          <Grid item>
                            <Button
                              startIcon={<TableViewIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleExportToAttendanceExcel}
                            >
                              Excel
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              startIcon={<LocalPrintshopSharpIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleExportToAttendancePDF}
                            >
                              pdf
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
  
                    <Grid>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheader}>
                                <strong>Date</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>clocked Hours</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Records</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {attendanceIsLoading ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="10vh"
                                  >
                                    <CircularProgress />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ) : attendanceIsError ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  "Error fetching data"
                                </TableCell>
                              </TableRow>
                            ) : attendanceData?.data &&
                              Object.entries(attendanceData.data).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={3} align="center">
                                  No data available
                                </TableCell>
                              </TableRow>
                            ) : (
                              Object.entries(attendanceData?.data || {})
                                .slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                                .map(([date, records], index) => {
                                  const clockedHours = records
                                    .map((record: IPunchEmpRecord) => {
                                      const punchIn = formatTime(
                                        record.punch_in_time
                                      );
  
                                      const punchOut = record.punch_out_time
                                        ? record.punch_in_date !==
                                          record.punch_out_date
                                          ? `${dayjs(
                                              record.punch_out_date
                                            ).format(
                                              "MMM-DD, YYYY"
                                            )} ${formatTime(
                                              record.punch_out_time
                                            )}`
                                          : formatTime(record.punch_out_time)
                                        : "Pending";
  
                                      return punchIn
                                        ? `${punchIn} - ${punchOut}`
                                        : "";
                                    })
                                    .join(", ");
  
                                  const actualClockedHours = records
                                    .map((record: IPunchEmpRecord) => {
                                      const punchInActual = formatTime(
                                        record.punch_in_actual_time
                                      );
                                      const punchOutActual =
                                        record.punch_out_actual_time
                                          ? formatTime(
                                              record.punch_out_actual_time
                                            )
                                          : "";
  
                                      return punchInActual
                                        ? `${punchInActual} - ${
                                            punchOutActual || "pending"
                                          }`
                                        : "";
                                    })
                                    .join(", ");
  
                                  return (
                                    <TableRow key={index}>
                                      <TableCell>
                                        {dayjs(date).format(
                                          "MMM-DD, YYYY (dddd)"
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {actualClockedHours || ""}
                                      </TableCell>
                                      <TableCell>{clockedHours || ""}</TableCell>
                                    </TableRow>
                                  );
                                })
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Grid
                        spacing={5}
                        p={"18px"}
                        py={10}
                        justifyContent={"end"}
                        container
                        textAlign={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid
                          sx={{
                            textAlign: "end",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Pagination
                            count={attendanceDataList.length}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={handleChangePage}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ) : (
                <div>No availability data to show</div>
              )}
            </Grid>
          );
        case Section.Payroll:
          return (
            <Grid container spacing={2}>
              {customer.availability && customer.availability.length > 0 ? (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Payroll List
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <Button
                              startIcon={<TableViewIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleExportToExcel}
                            >
                              Excel
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              startIcon={<LocalPrintshopSharpIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleExportToPDF}
                            >
                              pdf
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
  
                    <Grid>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell
                                className={classes.tablheader}
                                sx={{ width: "30%" }}
                              >
                                <strong>Payroll</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheader}
                                sx={{ width: "60%" }}
                              >
                                <strong>Details</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {payrollIsLoading || positionLoading ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="10vh"
                                  >
                                    <CircularProgress />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ) : payrollIsError || payrollDataList.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  {payrollIsError
                                    ? "Some thing went to wrong"
                                    : "No data available"}
                                </TableCell>
                              </TableRow>
                            ) : (
                              payrollDataList.map(
                                (row: IEmployeePayroll, index) => (
                                  <TableRow
                                    key={index}
                                    className={classes.tableRowHover}
                                    // sx={{
                                    //   backgroundColor: row.isPreviousPaymentPaid
                                    //     ? "#f79aa61c"
                                    //     : "transparent",
                                    // }}
                                  >
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {payrollMap.get(row.payrollId) || ""}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Grid
                                        container
                                        spacing={2}
                                        sx={{ padding: 2 }}
                                      >
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          className={
                                            classes.cardGreenBAckGroundColor
                                          }
                                        >
                                          <Grid container spacing={2}>
                                            {userHasRight(
                                              Privileges.ScheduleEdit
                                            ) && (
                                              <Grid
                                                item
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                              >
                                                <Grid
                                                  container
                                                  spacing={1}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                  }}
                                                >
                                                  <Tooltip
                                                    title={
                                                      <>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            Payroll List Details
                                                          </strong>
                                                        </Typography>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            for Employee records
                                                          </strong>
                                                        </Typography>
                                                      </>
                                                    }
                                                    sx={{ fontSize: "14px" }}
                                                  >
                                                    <Grid item>
                                                      <Button
                                                        // variant="contained"
                                                        className={
                                                          classes.viewButtonList
                                                        }
                                                        onClick={() =>
                                                          navigate(
                                                            `/emp/report/${row.payrollId}?empid=${row.empid}`
                                                          )
                                                        }
                                                      >
                                                        <PersonSearchRoundedIcon
                                                          className={
                                                            classes.viewListIcon
                                                          }
                                                        />
                                                      </Button>
                                                    </Grid>
                                                  </Tooltip>
                                                  <Tooltip
                                                    title={
                                                      <>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            View All
                                                          </strong>
                                                        </Typography>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            Punch Details Records
                                                          </strong>
                                                        </Typography>
                                                      </>
                                                    }
                                                    sx={{ fontSize: "14px" }}
                                                  >
                                                    <Grid item>
                                                      <Button
                                                        // variant="contained"
                                                        className={
                                                          classes.viewButtonList
                                                        }
                                                        onClick={() =>
                                                          handleViewClick(
                                                            String(row.empid),
                                                            String(row.payrollId),
                                                            String(
                                                              row.hourly_salary
                                                            ),
                                                            row
                                                          )
                                                        }
                                                      >
                                                        <ListIcon
                                                          className={
                                                            classes.viewListIcon
                                                          }
                                                        />
                                                      </Button>
                                                    </Grid>
                                                  </Tooltip>
                                                  <Tooltip
                                                    title={
                                                      <>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            View Adjustment Amount
                                                          </strong>
                                                        </Typography>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            && Edited Details
                                                          </strong>
                                                        </Typography>
                                                      </>
                                                    }
                                                    sx={{ fontSize: "14px" }}
                                                  >
                                                    <Grid item>
                                                      <Button
                                                        // variant="contained"
                                                        className={
                                                          classes.viewButtonList
                                                        }
                                                        onClick={() =>
                                                          handleEditOpen(row)
                                                        }
                                                      >
                                                        <VisibilitySharpIcon
                                                          className={
                                                            classes.viewListIcon
                                                          }
                                                        />
                                                      </Button>
                                                    </Grid>
                                                  </Tooltip>
                                                </Grid>
                                              </Grid>
                                            )}
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={8}
                                                  sm={8}
                                                  xs={8}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.cardGreenTypograpy
                                                    }
                                                  >
                                                    Normal Working Amount (
                                                    {Number(
                                                      row?.total_normal_hours || 0
                                                    ).toFixed(2)}
                                                    {" hrs * $"}
                                                    {Number(
                                                      row?.hourly_salary || 0
                                                    ).toFixed(2)}
                                                    )
                                                  </Typography>
                                                </Grid>
  
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={4}
                                                  xs={4}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                  }}
                                                  paddingRight={2}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.cardGreenTypograpy
                                                    }
                                                  >
                                                    {"$ "}
                                                    {Number(
                                                      Number(
                                                        row?.total_normal_hours ||
                                                          0
                                                      ) *
                                                        Number(
                                                          row?.hourly_salary || 0
                                                        )
                                                    ).toFixed(2)}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={8}
                                                  sm={8}
                                                  xs={8}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.cardGreenTypograpy
                                                    }
                                                  >
                                                    OT Amount (
                                                    {Number(
                                                      row?.total_ot_hours || 0
                                                    ).toFixed(2)}
                                                    {" hrs * $"}
                                                    {Number(
                                                      row?.ot_hourly_salary || 0
                                                    ).toFixed(2)}
                                                    )
                                                  </Typography>
                                                </Grid>
  
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={4}
                                                  xs={4}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                  }}
                                                  paddingRight={2}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.cardGreenTypograpy
                                                    }
                                                  >
                                                    {"$ "}
                                                    {Number(
                                                      Number(
                                                        row?.total_ot_hours || 0
                                                      ) *
                                                        Number(
                                                          row?.ot_hourly_salary ||
                                                            0
                                                        )
                                                    ).toFixed(2)}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={8}
                                                  sm={8}
                                                  xs={8}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.cardGreenTypograpy
                                                    }
                                                  >
                                                    Adjustment Amount
                                                  </Typography>
                                                </Grid>
  
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={4}
                                                  xs={4}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                  }}
                                                  paddingRight={2}
                                                  pb={1}
                                                  borderBottom={0.5}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.cardGreenTypograpy
                                                    }
                                                  >
                                                    {"$ "}
                                                    {Number(
                                                      row?.bonus_amount || 0
                                                    ).toFixed(2)}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              py={2}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={8}
                                                  sm={8}
                                                  xs={8}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Typography
                                                    className={classes.h4}
                                                  >
                                                    Total Amount
                                                  </Typography>
                                                </Grid>
  
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={4}
                                                  xs={4}
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                  }}
                                                  paddingRight={2}
                                                >
                                                  <Typography
                                                    className={classes.h4}
                                                  >
                                                    {"$ "}
                                                    {Number(
                                                      row?.total_salary || 0
                                                    ).toFixed(2)}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                )
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    <Dialog
                      open={isEditDialogOpen}
                      onClose={handleEditClose}
                      aria-describedby="alert-dialog-description"
                      classes={{ paper: "inherit" }}
                      fullScreen={isMobile}
                      fullWidth={isMobile}
                      maxWidth="lg"
                    >
                      <Grid className={classes.Dialog}>
                        <Grid container spacing={3}>
                          <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                            <Card className={classes.stepperCard}>
                              <Grid container spacing={1}>
                                <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                                  <Grid container spacing={2}>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      pt={2}
                                      className={classes.titleGridBottomBoredr}
                                    >
                                      <Grid
                                        container
                                        justifyContent={"space-between"}
                                        spacing={5}
                                        sx={{ borderBottom: 2, py: 2, px: 5 }}
                                        className={classes.titleGrid}
                                      >
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          pt={2}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                          }}
                                        >
                                          <Typography
                                            className={classes.cardTitle}
                                          >
                                            Payroll Details (
                                            {editData?.employee_name || ""})
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
  
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      pt={2}
                                    >
                                      <Grid container>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                          <Grid
                                            container
                                            justifyContent={"space-between"}
                                            sx={{ py: 2, px: 5 }}
                                            spacing={2}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              className={
                                                classes.backgroundColorView2
                                              }
                                              sx={{ pt: 3, px: 3 }}
                                            >
                                              <Grid container>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography variant="subtitle1">
                                                    <span
                                                      className={
                                                        classes.customerDetails
                                                      }
                                                    >
                                                      Normal Working Hours
                                                    </span>{" "}
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.staffTypograpy
                                                    }
                                                  >
                                                    {editData?.total_normal_hours ||
                                                      "0.00"}
                                                    {" hrs"}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              className={
                                                classes.backgroundColorView2
                                              }
                                              sx={{ pb: 3, px: 3 }}
                                            >
                                              <Grid container>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography variant="subtitle1">
                                                    <span
                                                      className={
                                                        classes.customerDetails
                                                      }
                                                    >
                                                      Wrk Hourly Salary
                                                    </span>{" "}
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.staffTypograpy
                                                    }
                                                  >
                                                    {"$ "}{" "}
                                                    {editData?.hourly_salary ||
                                                      "0.00"}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                          <Grid
                                            container
                                            justifyContent={"space-between"}
                                            sx={{ py: 2, px: 5 }}
                                            spacing={2}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              className={
                                                classes.backgroundColorView2
                                              }
                                              sx={{ pt: 3, px: 3 }}
                                            >
                                              <Grid container>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography variant="subtitle1">
                                                    <span
                                                      className={
                                                        classes.customerDetails
                                                      }
                                                    >
                                                      OT Hours
                                                    </span>{" "}
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.staffTypograpy
                                                    }
                                                  >
                                                    {editData?.total_ot_hours ||
                                                      "0.00"}
                                                    {" hrs"}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              className={
                                                classes.backgroundColorView2
                                              }
                                              sx={{ pb: 3, px: 3 }}
                                            >
                                              <Grid container>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography variant="subtitle1">
                                                    <span
                                                      className={
                                                        classes.customerDetails
                                                      }
                                                    >
                                                      OT Hourly Salary
                                                    </span>{" "}
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Typography
                                                    className={
                                                      classes.staffTypograpy
                                                    }
                                                  >
                                                    {"$ "}
                                                    {editData?.ot_hourly_salary ||
                                                      "0.00"}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    {editData &&
                                      editData.bonus_adjustments.length > 0 && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          pt={2}
                                        >
                                          <Grid
                                            container
                                            justifyContent={"space-between"}
                                            sx={{ py: 2, px: 5 }}
                                            spacing={2}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              className={
                                                classes.backgroundColorView2
                                              }
                                              sx={{
                                                py: 3,
                                                px: 3,
                                                minHeight: "150px",
                                              }}
                                            >
                                              <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                spacing={2}
                                                paddingTop={5}
                                              >
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <TableContainer>
                                                    <Table
                                                      className={classes.table}
                                                    >
                                                      <TableHead
                                                        className={
                                                          classes.tableHeaderRow
                                                        }
                                                      >
                                                        <TableRow>
                                                          <TableCell
                                                            className={
                                                              classes.tablheader
                                                            }
                                                            sx={{ width: "50%" }}
                                                          >
                                                            <strong>
                                                              Remark
                                                            </strong>
                                                          </TableCell>
                                                          <TableCell
                                                            className={
                                                              classes.tablheader
                                                            }
                                                            sx={{ width: "20%" }}
                                                          >
                                                            <strong>
                                                              Action
                                                            </strong>
                                                          </TableCell>
                                                          <TableCell
                                                            className={
                                                              classes.tablheader
                                                            }
                                                            sx={{ width: "25%" }}
                                                          >
                                                            <strong>
                                                              Amount
                                                            </strong>
                                                          </TableCell>
                                                        </TableRow>
                                                      </TableHead>
                                                      <TableBody>
                                                        {editData?.bonus_adjustments.map(
                                                          (adjustment, index) => (
                                                            <TableRow
                                                              key={index}
                                                              className={
                                                                classes.tableRowHover
                                                              }
                                                            >
                                                              <TableCell
                                                                scope="row"
                                                                sx={{
                                                                  width: "50%",
                                                                }}
                                                                className={
                                                                  classes.tablCell
                                                                }
                                                              >
                                                                <TextField
                                                                  placeholder="Remark"
                                                                  size="small"
                                                                  value={
                                                                    adjustment.remark
                                                                  }
                                                                  // onChange={(e) =>
                                                                  //   handleAdjustmentChange(
                                                                  //     index,
                                                                  //     "remark",
                                                                  //     e.target.value
                                                                  //   )
                                                                  // }
                                                                  className={
                                                                    classes.textField
                                                                  }
                                                                  InputProps={{
                                                                    readOnly:
                                                                      true,
                                                                    sx: {
                                                                      fontSize: 14,
                                                                      border:
                                                                        "none",
                                                                    },
                                                                    classes: {
                                                                      root: classes.textFieldQuoteNoBorder,
                                                                      notchedOutline:
                                                                        classes.notchedOutline,
                                                                    },
                                                                  }}
                                                                  InputLabelProps={{
                                                                    sx: {
                                                                      fontSize: 14,
                                                                      border:
                                                                        "none",
                                                                    },
                                                                  }}
                                                                />
                                                              </TableCell>
                                                              <TableCell
                                                                scope="row"
                                                                sx={{
                                                                  width: "20%",
                                                                }}
                                                                className={
                                                                  classes.tablCell
                                                                }
                                                              >
                                                                <TextField
                                                                  select
                                                                  size="small"
                                                                  fullWidth
                                                                  className={
                                                                    classes.textField
                                                                  }
                                                                  InputProps={{
                                                                    readOnly:
                                                                      true,
                                                                    sx: {
                                                                      fontSize: 14,
                                                                      border:
                                                                        "none",
                                                                    },
                                                                    classes: {
                                                                      root: classes.textFieldQuoteNoBorder,
                                                                      notchedOutline:
                                                                        classes.notchedOutline,
                                                                    },
                                                                  }}
                                                                  InputLabelProps={{
                                                                    shrink: true,
                                                                    sx: {
                                                                      fontSize: 14,
                                                                      border:
                                                                        "none",
                                                                    },
                                                                  }}
                                                                  value={
                                                                    adjustment.selector
                                                                  }
                                                                  // onChange={(e) =>
                                                                  //   handleAdjustmentChange(
                                                                  //     index,
                                                                  //     "selector",
                                                                  //     e.target.value
                                                                  //   )
                                                                  // }
                                                                >
                                                                  <MenuItem value="add">
                                                                    Add
                                                                  </MenuItem>
                                                                  <MenuItem value="remove">
                                                                    Remove
                                                                  </MenuItem>
                                                                </TextField>
                                                              </TableCell>
                                                              <TableCell
                                                                scope="row"
                                                                sx={{
                                                                  width: "25%",
                                                                }}
                                                                className={
                                                                  classes.tablCell
                                                                }
                                                              >
                                                                <TextField
                                                                  placeholder="Amount"
                                                                  size="small"
                                                                  value={
                                                                    adjustment.value
                                                                  }
                                                                  // onChange={(e) =>
                                                                  //   handleAdjustmentChange(
                                                                  //     index,
                                                                  //     "value",
                                                                  //     parseFloat(e.target.value)
                                                                  //   )
                                                                  // }
                                                                  type="number"
                                                                  className={
                                                                    classes.textField
                                                                  }
                                                                  InputProps={{
                                                                    readOnly:
                                                                      true,
                                                                    sx: {
                                                                      fontSize: 14,
                                                                      border:
                                                                        "none",
                                                                    },
                                                                    classes: {
                                                                      root: classes.textFieldQuoteNoBorder,
                                                                      notchedOutline:
                                                                        classes.notchedOutline,
                                                                    },
                                                                  }}
                                                                  InputLabelProps={{
                                                                    sx: {
                                                                      fontSize: 14,
                                                                      border:
                                                                        "none",
                                                                    },
                                                                  }}
                                                                />
                                                              </TableCell>
                                                            </TableRow>
                                                          )
                                                        )}
                                                      </TableBody>
                                                    </Table>
                                                  </TableContainer>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    {editData && editData.edited_reason && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        pt={2}
                                      >
                                        <Grid
                                          container
                                          justifyContent={"space-between"}
                                          sx={{ py: 2, px: 5 }}
                                          spacing={2}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className={
                                              classes.backgroundColorView2
                                            }
                                            sx={{
                                              py: 3,
                                              px: 3,
                                              minHeight: "150px",
                                            }}
                                          >
                                            <Grid container>
                                              <Grid
                                                item
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                              >
                                                <Typography variant="subtitle1">
                                                  <span
                                                    className={
                                                      classes.customerDetails
                                                    }
                                                  >
                                                    Note
                                                  </span>{" "}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                              >
                                                <Typography>
                                                  {editData?.edited_reason || ""}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
  
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      pt={2}
                                    >
                                      <Grid
                                        container
                                        justifyContent={"space-between"}
                                        sx={{ py: 2, px: 5 }}
                                        spacing={2}
                                      >
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid container spacing={2}>
                                            <Grid item lg={6} md={6}></Grid>
  
                                            <Grid
                                              item
                                              lg={6}
                                              md={6}
                                              sm={12}
                                              xs={12}
                                              className={
                                                classes.cardGreenBAckGroundColor
                                              }
                                            >
                                              <Grid container spacing={2}>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Grid container spacing={2}>
                                                    <Grid
                                                      item
                                                      lg={8}
                                                      md={8}
                                                      sm={8}
                                                      xs={8}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-start",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.cardGreenTypograpy
                                                        }
                                                      >
                                                        Normal Working Amount (
                                                        {Number(
                                                          editData?.total_normal_hours ||
                                                            0
                                                        ).toFixed(2)}
                                                        {" hrs * $"}
                                                        {Number(
                                                          editData?.hourly_salary ||
                                                            0
                                                        ).toFixed(2)}
                                                        )
                                                      </Typography>
                                                    </Grid>
  
                                                    <Grid
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={4}
                                                      xs={4}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-end",
                                                        alignItems: "center",
                                                      }}
                                                      paddingRight={2}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.cardGreenTypograpy
                                                        }
                                                      >
                                                        {"$ "}
                                                        {Number(
                                                          Number(
                                                            editData?.total_normal_hours ||
                                                              0
                                                          ) *
                                                            Number(
                                                              editData?.hourly_salary ||
                                                                0
                                                            )
                                                        ).toFixed(2)}
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Grid container spacing={2}>
                                                    <Grid
                                                      item
                                                      lg={8}
                                                      md={8}
                                                      sm={8}
                                                      xs={8}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-start",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.cardGreenTypograpy
                                                        }
                                                      >
                                                        OT Amount (
                                                        {Number(
                                                          editData?.total_ot_hours ||
                                                            0
                                                        ).toFixed(2)}
                                                        {" hrs * $"}
                                                        {Number(
                                                          editData?.ot_hourly_salary ||
                                                            0
                                                        ).toFixed(2)}
                                                        )
                                                      </Typography>
                                                    </Grid>
  
                                                    <Grid
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={4}
                                                      xs={4}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-end",
                                                        alignItems: "center",
                                                      }}
                                                      paddingRight={2}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.cardGreenTypograpy
                                                        }
                                                      >
                                                        {"$ "}
                                                        {Number(
                                                          Number(
                                                            editData?.total_ot_hours ||
                                                              0
                                                          ) *
                                                            Number(
                                                              editData?.ot_hourly_salary ||
                                                                0
                                                            )
                                                        ).toFixed(2)}
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <Grid container spacing={2}>
                                                    <Grid
                                                      item
                                                      lg={8}
                                                      md={8}
                                                      sm={8}
                                                      xs={8}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-start",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.cardGreenTypograpy
                                                        }
                                                      >
                                                        Adjustment Amount
                                                      </Typography>
                                                    </Grid>
  
                                                    <Grid
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={4}
                                                      xs={4}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-end",
                                                        alignItems: "center",
                                                      }}
                                                      paddingRight={2}
                                                      pb={1}
                                                      borderBottom={0.5}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.cardGreenTypograpy
                                                        }
                                                      >
                                                        {"$ "}
                                                        {Number(
                                                          editData?.bonus_amount ||
                                                            0
                                                        ).toFixed(2)}
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  py={2}
                                                >
                                                  <Grid container spacing={2}>
                                                    <Grid
                                                      item
                                                      lg={8}
                                                      md={8}
                                                      sm={8}
                                                      xs={8}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-start",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={classes.h4}
                                                      >
                                                        Total Amount
                                                      </Typography>
                                                    </Grid>
  
                                                    <Grid
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={4}
                                                      xs={4}
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-end",
                                                        alignItems: "center",
                                                      }}
                                                      paddingRight={2}
                                                    >
                                                      <Typography
                                                        className={classes.h4}
                                                      >
                                                        {"$ "}
                                                        {Number(
                                                          editData?.total_salary ||
                                                            0
                                                        ).toFixed(2)}
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      pt={2}
                                    >
                                      <Grid
                                        container
                                        justifyContent={"space-between"}
                                        sx={{ py: 2, px: 5 }}
                                        spacing={2}
                                      >
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid container>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <Button
                                                variant="outlined"
                                                startIcon={<CloseIcon />}
                                                className={classes.addButton}
                                                onClick={handleEditClose}
                                              >
                                                Cancel
                                              </Button>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Dialog>
  
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-describedby="alert-dialog-description"
                      classes={{ paper: "inherit" }}
                      fullScreen={isMobile}
                      fullWidth={isMobile}
                      maxWidth="lg"
                    >
                      <Grid className={classes.Dialog}>
                        <Grid container spacing={3}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.card}>
                              <Grid
                                container
                                justifyContent={"space-between"}
                                spacing={5}
                                sx={{ borderBottom: 2, padding: 2 }}
                                className={classes.titleGrid}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  pt={2}
                                  alignContent={"center"}
                                >
                                  <Typography className={classes.cardTitle}>
                                    Employee Payroll Details
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
  
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={3}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Card className={classes.card}>
                                  <Grid
                                    container
                                    justifyContent={"space-between"}
                                    spacing={5}
                                    sx={{ borderBottom: 2, padding: 2 }}
                                    className={classes.titleGrid}
                                  >
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      xs={12}
                                      pt={2}
                                      alignContent={"center"}
                                    >
                                      <Typography className={classes.cardTitle}>
                                        {(customer.teamFirstName || "") +
                                          " " +
                                          (customer.teamLastName || "")}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={8}
                                      xs={8}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={1}
                                        justifyContent="flex-end"
                                        sx={{ display: "flex" }}
                                      >
                                        <Grid item>
                                          <Button
                                            startIcon={
                                              <LocalPrintshopSharpIcon />
                                            }
                                            className={classes.addButtonPdfExcel}
                                            onClick={handleEmployeePunchExcel}
                                          >
                                            Excel
                                          </Button>
                                        </Grid>
                                        <Grid item>
                                          <Button
                                            startIcon={
                                              <LocalPrintshopSharpIcon />
                                            }
                                            className={classes.addButtonPdfExcel}
                                            onClick={
                                              handleExportToPDFForEmployeePunch
                                            }
                                          >
                                            pdf
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
  
                                  <Grid container spacing={3}>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <TableContainer>
                                        <Table className={classes.table}>
                                          <TableHead
                                            className={classes.tableHeaderRow}
                                          >
                                            <TableRow>
                                              <TableCell
                                                className={classes.tablheader}
                                              >
                                                <strong>Date</strong>
                                              </TableCell>
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "left" }}
                                              >
                                                <strong>Records</strong>
                                              </TableCell>
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "right" }}
                                              >
                                                <strong>Actual Hours</strong>
                                              </TableCell>
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "right" }}
                                              >
                                                <strong>Total Break Hours</strong>
                                              </TableCell>
  
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "right" }}
                                              >
                                                <strong>
                                                  Total working hours
                                                </strong>
                                              </TableCell>
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "right" }}
                                              >
                                                <strong>Hourly Salary</strong>
                                              </TableCell>
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "right" }}
                                              >
                                                <strong>Total Amount</strong>
                                              </TableCell>
                                              {/* <TableCell
                                    className={classes.tablheader}
                                    sx={{ textAlign: "right" }}
                                  >
                                    <strong>Actions</strong>
                                  </TableCell> */}
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {payRollAnEmployeeLoading ||
                                            positionLoading ? (
                                              <TableRow>
                                                <TableCell
                                                  colSpan={20}
                                                  align="center"
                                                >
                                                  <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    height="10vh"
                                                  >
                                                    <CircularProgress />
                                                  </Box>
                                                </TableCell>
                                              </TableRow>
                                            ) : payRollAnEmployeeIsError ||
                                              EmployeePunchRecord.length === 0 ? (
                                              <TableRow>
                                                <TableCell
                                                  colSpan={20}
                                                  align="center"
                                                >
                                                  {isError
                                                    ? "Error fetching data"
                                                    : "No data available"}
                                                </TableCell>
                                              </TableRow>
                                            ) : (
                                              EmployeePunchRecord.map(
                                                (
                                                  row: IEmployeePunchRecord,
                                                  index
                                                ) => (
                                                  <TableRow
                                                    key={row.id}
                                                    className={
                                                      classes.tableRowHover
                                                    }
                                                  >
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                    >
                                                      {dayjs(
                                                        row.recordDate
                                                      ).format("YYYY-MM-DD")}
                                                    </TableCell>
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "left" }}
                                                    >
                                                      {row.punchDetails.length >
                                                      0 ? (
                                                        row.punchDetails.map(
                                                          (
                                                            punchDetail,
                                                            index
                                                          ) => {
                                                            const punchInTime =
                                                              formatTime(
                                                                punchDetail.punch_in_time
                                                              );
                                                            const punchOutTime =
                                                              punchDetail.punch_out_time
                                                                ? punchDetail.punch_in_date !==
                                                                  punchDetail.punch_out_date
                                                                  ? `${dayjs(
                                                                      punchDetail.punch_out_date
                                                                    ).format(
                                                                      "MMM-DD, YYYY"
                                                                    )} ${formatTime(
                                                                      punchDetail.punch_out_time
                                                                    )}`
                                                                  : formatTime(
                                                                      punchDetail.punch_out_time
                                                                    )
                                                                : "Pending";
  
                                                            return (
                                                              <span key={index}>
                                                                {punchInTime} -{" "}
                                                                {punchOutTime}
                                                                {index !==
                                                                  row.punchDetails
                                                                    .length -
                                                                    1 && ", "}
                                                              </span>
                                                            );
                                                          }
                                                        )
                                                      ) : (
                                                        <span> </span>
                                                      )}
                                                    </TableCell>
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "right" }}
                                                    >
                                                      {row.break_hours === null ||
                                                      row.total_hours === null ||
                                                      isNaN(
                                                        parseFloat(
                                                          String(row.break_hours)
                                                        )
                                                      ) ||
                                                      isNaN(
                                                        parseFloat(
                                                          String(row.total_hours)
                                                        )
                                                      )
                                                        ? ""
                                                        : parseFloat(
                                                            String(
                                                              row.break_hours
                                                            )
                                                          ) +
                                                            parseFloat(
                                                              String(
                                                                row.total_hours
                                                              )
                                                            ) ===
                                                          0
                                                        ? "-"
                                                        : `${(
                                                            parseFloat(
                                                              String(
                                                                row.break_hours
                                                              )
                                                            ) +
                                                            parseFloat(
                                                              String(
                                                                row.total_hours
                                                              )
                                                            )
                                                          ).toFixed(2)} hrs`}
                                                    </TableCell>
  
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "right" }}
                                                    >
                                                      {row.break_hours === null ||
                                                      isNaN(
                                                        parseFloat(
                                                          String(row.break_hours)
                                                        )
                                                      )
                                                        ? ""
                                                        : parseFloat(
                                                            String(
                                                              row.break_hours
                                                            )
                                                          ) === 0
                                                        ? "-"
                                                        : `${parseFloat(
                                                            String(
                                                              row.break_hours
                                                            )
                                                          ).toFixed(2)} hrs`}
                                                    </TableCell>
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "right" }}
                                                    >
                                                      {row.total_hours === null ||
                                                      isNaN(
                                                        parseFloat(
                                                          String(row.total_hours)
                                                        )
                                                      )
                                                        ? ""
                                                        : parseFloat(
                                                            String(
                                                              row.total_hours
                                                            )
                                                          ) === 0
                                                        ? "-"
                                                        : `${parseFloat(
                                                            String(
                                                              row.total_hours
                                                            )
                                                          ).toFixed(2)} hrs`}
                                                    </TableCell>
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "right" }}
                                                    >
                                                      {selectedHrs === null ||
                                                      isNaN(
                                                        parseFloat(
                                                          String(selectedHrs)
                                                        )
                                                      )
                                                        ? ""
                                                        : parseFloat(
                                                            String(selectedHrs)
                                                          ) === 0
                                                        ? "-"
                                                        : `$ ${parseFloat(
                                                            String(selectedHrs)
                                                          ).toFixed(2)}`}
                                                    </TableCell>
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "right" }}
                                                    >
                                                      {selectedHrs === null ||
                                                      row.total_hours === null ||
                                                      isNaN(
                                                        parseFloat(
                                                          String(selectedHrs)
                                                        ) * row.total_hours
                                                      )
                                                        ? ""
                                                        : parseFloat(
                                                            String(selectedHrs)
                                                          ) *
                                                            row.total_hours ===
                                                          0
                                                        ? "-"
                                                        : `$ ${(
                                                            parseFloat(
                                                              String(selectedHrs)
                                                            ) * row.total_hours
                                                          ).toFixed(2)}`}
                                                    </TableCell>
                                                    {/* <TableCell className={classes.tablCell}>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <Button
                                            // variant="contained"
                                            className={classes.editButtonList}
                                            onClick={() =>
                                              handleDateViewClick(
                                                String(row.recordDate)
                                              )
                                            }
                                          >
                                            <VisibilitySharpIcon
                                              className={classes.editListIcon}
                                            />
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </TableCell> */}
                                                  </TableRow>
                                                )
                                              )
                                            )}
  
                                            <TableRow
                                              className={classes.tableRowHover}
                                            >
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                              ></TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                sx={{ textAlign: "left" }}
                                              ></TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                sx={{ textAlign: "right" }}
                                              ></TableCell>
  
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {coursingToDelete &&
                                                coursingToDelete.total_break_hours !==
                                                  null &&
                                                !isNaN(
                                                  parseFloat(
                                                    String(
                                                      coursingToDelete.total_break_hours
                                                    )
                                                  )
                                                )
                                                  ? parseFloat(
                                                      String(
                                                        coursingToDelete.total_break_hours
                                                      )
                                                    ) === 0
                                                    ? "-"
                                                    : `${parseFloat(
                                                        String(
                                                          coursingToDelete.total_break_hours
                                                        )
                                                      ).toFixed(2)} hrs`
                                                  : ""}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {coursingToDelete &&
                                                coursingToDelete.total_hours !==
                                                  null &&
                                                !isNaN(
                                                  parseFloat(
                                                    String(
                                                      coursingToDelete.total_hours
                                                    )
                                                  )
                                                )
                                                  ? parseFloat(
                                                      String(
                                                        coursingToDelete.total_hours
                                                      )
                                                    ) === 0
                                                    ? "-"
                                                    : `${parseFloat(
                                                        String(
                                                          coursingToDelete.total_hours
                                                        )
                                                      ).toFixed(2)} hrs`
                                                  : ""}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                sx={{ textAlign: "right" }}
                                              ></TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCell}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {coursingToDelete &&
                                                coursingToDelete.gross_salary !==
                                                  null &&
                                                !isNaN(
                                                  parseFloat(
                                                    String(
                                                      coursingToDelete.gross_salary
                                                    )
                                                  )
                                                )
                                                  ? parseFloat(
                                                      String(
                                                        coursingToDelete.gross_salary
                                                      )
                                                    ) === 0
                                                    ? "-"
                                                    : `$ ${parseFloat(
                                                        String(
                                                          coursingToDelete.gross_salary
                                                        )
                                                      ).toFixed(2)}`
                                                  : ""}
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Grid>
                                  </Grid>
                                </Card>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Card className={classes.card}>
                                  <Grid container spacing={3} p={"24px"}>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Button
                                        variant="outlined"
                                        startIcon={<CloseIcon />}
                                        className={classes.addButton}
                                        onClick={handleClose}
                                      >
                                        Cancel
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Card>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Dialog>
  
                    <Dialog
                      open={openAdminConfim}
                      onClose={() => setOpenAdminConfim(false)}
                      sx={{ padding: 5, minWidth: 450 }}
                    >
                      <Grid className={classes.Dialog}>
                        <Grid container spacing={3}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={3}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Card className={classes.card}>
                                  <Grid
                                    container
                                    justifyContent={"space-between"}
                                    spacing={5}
                                    sx={{ borderBottom: 2, padding: 2 }}
                                    className={classes.titleGrid}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      pt={2}
                                      alignContent={"center"}
                                    >
                                      <Typography className={classes.cardTitle}>
                                        Employee Payroll Date Details
                                      </Typography>
                                    </Grid>
                                  </Grid>
  
                                  <Grid container spacing={3} p={"24px"}>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <TableContainer>
                                        <Table className={classes.table}>
                                          <TableHead
                                            className={classes.tableHeaderRow}
                                          >
                                            <TableRow>
                                              <TableCell
                                                className={classes.tablheader}
                                              >
                                                <strong>Date</strong>
                                              </TableCell>
                                              <TableCell
                                                className={classes.tablheader}
                                                sx={{ textAlign: "center" }}
                                              >
                                                <strong>Time Range</strong>
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {payRollEachEmployeeLoading ? (
                                              <TableRow>
                                                <TableCell
                                                  colSpan={20}
                                                  align="center"
                                                >
                                                  <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    height="10vh"
                                                  >
                                                    <CircularProgress />
                                                  </Box>
                                                </TableCell>
                                              </TableRow>
                                            ) : payRollEachEmployeeIsError ||
                                              EmployeePunchRecord.length === 0 ? (
                                              <TableRow>
                                                <TableCell
                                                  colSpan={20}
                                                  align="center"
                                                >
                                                  {isError
                                                    ? "Error fetching data"
                                                    : "No data available"}
                                                </TableCell>
                                              </TableRow>
                                            ) : (
                                              EmpEachPunchRecord.map(
                                                (
                                                  row: IPayrollEachEmployeDateList,
                                                  index
                                                ) => (
                                                  <TableRow
                                                    key={row.id}
                                                    className={
                                                      classes.tableRowHover
                                                    }
                                                  >
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                    >
                                                      {dayjs(
                                                        row.punch_in_date
                                                      ).format("YYYY-MM-DD")}
                                                    </TableCell>
                                                    <TableCell
                                                      scope="row"
                                                      className={classes.tablCell}
                                                      sx={{ textAlign: "center" }}
                                                    >
                                                      {formatTime(
                                                        row.punch_in_time
                                                      )}{" "}
                                                      -{" "}
                                                      {formatTime(
                                                        row.punch_out_time
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                )
                                              )
                                            )}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Grid>
                                  </Grid>
                                </Card>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Card className={classes.card}>
                                  <Grid container spacing={3} p={"24px"}>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Button
                                        variant="outlined"
                                        startIcon={<CloseIcon />}
                                        className={classes.addButton}
                                        onClick={() =>
                                          handleDialogCloseAdminConform(false)
                                        }
                                      >
                                        Cancel
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Card>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Dialog>
                  </Card>
                </Grid>
              ) : (
                <div>No availability data to show</div>
              )}
            </Grid>
          );
      default:
        return null;
    }
  };

  const timeLineSteps: IPunchDetails[] = Array.isArray(activityData?.data)
    ? (activityData?.data as IPunchDetails[])
    : [];

  const toggleStepDetails = (index: number) => {
    if (expandedSteps.includes(index)) {
      setExpandedSteps(
        expandedSteps.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedSteps([...expandedSteps, index]);
    }
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={8} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.profileBottomSetUp}
                  >
                    <Grid className={classes.profileBottomDwon}>
                      {customer ? (
                        customer.teamImg ? (
                          <img
                            src={customer.teamImg}
                            alt="Profile"
                            className={classes.profileImage}
                          />
                        ) : (
                          <Avatar
                            alt="Travis Howard"
                            src={AvatarImg}
                            className={classes.profileImage}
                          />
                        )
                      ) : (
                        <Avatar
                          alt="Travis Howard"
                          src={AvatarImg}
                          className={classes.profileImage}
                        />
                      )}
                    </Grid>

                    {/* <Grid className={classes.profileDetails}>
                      <Box className={classes.staffNameBox}>
                        <Typography
                          sx={{
                            textTransform: "uppercase",
                            fontSize: "13px",
                            px: 3,
                          }}
                        >
                          {(customer.teamFirstName || "") +
                            " " +
                            (customer.teamLastName || "")}
                        </Typography>
                      </Box>


                     
                    </Grid> */}
                    <Grid className={classes.buttonGroupList}>
                      <Typography
                        variant="h4"
                        className={classes.profileDetailItemList}
                      >
                        {capitalizeFirstLetter(customer.teamFirstName || "") +
                          " " +
                          capitalizeFirstLetter(customer.teamLastName || "")}
                      </Typography>
                      {customer.teamId && (
                        <Typography variant="subtitle1" sx={{ px: "3px" }}>
                          <span className={classes.customerDetails}>
                            {` (${customer.teamId})`}
                          </span>{" "}
                        </Typography>
                      )}
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      className={classes.buttonGroupList}
                    >
                      {customer.teamMobileNum && (
                        <Grid item>
                          <Typography
                            // variant="body1"
                            className={classes.contactInfoProfile}
                          >
                            {customer.teamMobileNum && (
                              <span className={classes.iconText}>
                                {formatPhoneNumberForDisplaySpace(
                                  customer.teamMobileNum
                                )}
                              </span>
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {customer.teamEmail && (
                        <Grid item>
                          <Typography
                            // variant="body1"
                            className={classes.contactInfoProfile}
                          >
                            {customer.teamEmail && (
                              <span className={classes.iconText}>
                                {customer.teamEmail}
                              </span>
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {/* <Typography
                          variant="body1"
                          className={classes.contactInfo}
                        >
                          {customer.customerMobileNum && (
                            <span className={classes.iconText}>
                              <PhoneIcon /> {customer.customerMobileNum}
                            </span>
                          )}
                          {customer.customerEmail && (
                            <span className={classes.iconText}>
                              <EmailIcon /> {customer.customerEmail}
                            </span>
                          )}
                        </Typography> */}
                    </Grid>

                    <Grid>
                      <Grid className={classes.buttonGroup}>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Info)}
                          >
                            <InfoOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Info
                          </Typography>
                        </div>
                        {/* <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Email)}
                          >
                            <EmailOutlined />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Email
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Email)}
                          >
                            <PhoneIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Call
                          </Typography>
                        </div> */}

                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.TimeSlot)
                            }
                          >
                            <AccessTimeRoundedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Schedule
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.Payroll)
                            }
                          >
                            <AttachMoneySharpIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Payroll
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.Attendance)
                            }
                          >
                            <ChecklistRtlIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Clock In/Out
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {renderContent()}
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography
                          className={classes.ActivityHistoryHEading}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <UpdateOutlinedIcon style={{ marginRight: "8px" }} />
                          Activity History
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                        className={classes.titleGrid}
                      >
                        <Box
                          sx={{
                            height: "720px",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                          <Stepper
                            orientation="vertical"
                            activeStep={timeLineSteps.length}
                          >
                            {timeLineSteps.map((step, index) => (
                              <Step key={step.id} completed>
                                <StepLabel>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Typography className={classes.h5}>
                                      <span
                                        style={{
                                          color:
                                            step.punch_action === "punch_in"
                                              ? "#007f00"
                                              : step.punch_action ===
                                                "punch_out"
                                              ? "#e3791a"
                                              : "inherit",
                                        }}
                                      >
                                        {step.punch_action === "punch_in"
                                          ? "Punch In"
                                          : step.punch_action === "punch_out"
                                          ? "Punch Out"
                                          : step.punch_action}
                                      </span>

                                      <Typography
                                        variant="subtitle1"
                                        className={classes.showMoreLink}
                                        onClick={() => toggleStepDetails(index)}
                                      >
                                        {expandedSteps.includes(index)
                                          ? "Show less"
                                          : "Show more"}
                                      </Typography>
                                      <Typography>
                                        {dayjs(step.punched_date).format(
                                          "MMM-DD, YYYY"
                                        )}
                                      </Typography>
                                    </Typography>
                                    <br />
                                    <Typography>
                                      {dayjs(step.punched_time).format(
                                        "hh:mm A"
                                      )}
                                    </Typography>
                                  </Box>
                                </StepLabel>

                                {expandedSteps.includes(index) && (
                                  <Box sx={{ ml: 4, mt: 1 }}>
                                    <Typography>
                                      {/* {dayjs(step.punched_time).format(
                                        "hh:mm A"
                                      )} */}
                                    </Typography>
                                  </Box>
                                )}
                              </Step>
                            ))}

                            {/* <Step>
                              <StepLabel>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Typography>Next...</Typography>
                                  <Button
                                    // variant="contained"
                                    className={classes.editButtonList}
                                  >
                                    <CircularProgress size={24} />
                                  </Button>
                                </Box>
                              </StepLabel>
                            </Step> */}
                          </Stepper>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {selectCustomer && (
        <NewPopUpteam
          openModel={openDialog}
          handleCloseDialog={handleCloseDialog}
          data={selectCustomer}
        />
      )}
      {selectCustomer2 && (
        <NewPopUpteamscheduleEdit
          openModel={openDialog2}
          handleCloseDialog={handleCloseDialog2}
          data={selectCustomer2}
        />
      )}
    </div>
  );
};

export default Index;
